<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">优惠卡名称:</span>
                        <!-- 搜索优惠卡名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入优惠卡名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOfflineDiscountCardLists"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">优惠卡编码:</span>
                        <!-- 搜索优惠卡编码 -->
                        <el-input
                            v-model="search_data.card_code"
                            placeholder="请输入优惠卡编码"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOfflineDiscountCardLists"
                        ></el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="24" style="margin-top: 10px">
                        <span class="title">创建时间:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchOfflineDiscountCardLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="add_isShow = !add_isShow">新增优惠卡</el-button>
            <el-button type="danger" @click="batchDelete">批量删除</el-button>
            <el-button type="info" @click="batchDownZipPromotionQR">批量下载</el-button>
            <!-- <el-button
                :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
                @click="allDownZipPromotionQR"
                :disabled="progress_show"
                >{{ progress_show ? '批量下载中...' : '批量下载全部' }}
            </el-button> -->
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="card_code" label="二维码" min-width="120">
                <template slot-scope="scope">
                    <el-image
                        style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                        :src="scope.row.qrcode.url"
                        v-if="scope.row.qrcode.url != ''"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column label="优惠卡名称" prop="name"> </el-table-column>
            <el-table-column label="编码" prop="card_code"> </el-table-column>
            <el-table-column label="创建时间" prop="time.YmdHis"> </el-table-column>
            <el-table-column label="优惠金额" prop="amount"> </el-table-column>
            <el-table-column label="线下支付" prop="offline_pay.alias"> </el-table-column>
            <el-table-column label="模式" prop="order_mode"> </el-table-column>
            <el-table-column label="到期时间" prop="expire_time"> </el-table-column>

            <el-table-column width="280px" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.loading" icon="el-icon-loading" disabled></el-button>
                    <template v-else>
                        <el-button type="primary" size="mini" @click="downZipPromotionQR(scope.row)">下载 </el-button>
                    </template>
                    <el-button type="danger" trigger="click" @click="deletePromotionQR(scope.row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
        <!-- 添加组件 -->
        <addofflineDiscountCardSub :isShow="add_isShow" @onSubmit="searchOfflineDiscountCardLists"></addofflineDiscountCardSub>
    </div>
</template>

<script>
var _this;
import addofflineDiscountCardSub from './addofflineDiscountCardSub.vue';

import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    components: {
        addofflineDiscountCardSub
    },
    data() {
        return {
            add_isShow: false,
            search_time: '',
            tableDataAll: [],
            progress_show: false,
            card_code: '',
            srcList: [],
            card_code: [],

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                card_code: '',
                created_at: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchOfflineDiscountCardLists();
    },

    methods: {
        // 全选或多选
        handleSelectionChange(val) {
            console.log(val, 'val');
            var datalist = [];

            if (val.length != 0) {
                for (var i in val) {
                    datalist.push(val[i].card_code);
                }
                _this.card_code = datalist;
            } else {
                _this.card_code = [];
            }
        },
        // 批量下载
        allDownZipPromotionQR() {
            _this.search_data.limit = 50;
            _this.dao();
        },
        dao() {
            _this
                .$post('/offlinediscountcard/offlineDiscountCardLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableDataAll.push(res.data);

                    if (_this.search_data.page * _this.search_data.limit < res.data.count) {
                        _this.search_data.page = _this.search_data.page + 1;

                        _this.allDownZipPromotionQR();
                    } else {
                        if (_this.tableDataAll.length != 0) {
                            for (let i = 0; i < _this.tableDataAll.length; i++) {
                                for (let j = 0; j < _this.tableDataAll[i].length; j++) {
                                    _this.card_code.push(_this.tableDataAll[i][j].card_code);
                                }
                            }

                            _this.downZipBusiness('piliang');
                            _this.search_data.page = 1;
                            _this.search_data.limit = 10;
                            // 清空数据
                            _this.tableDataAll = [];
                            _this.progress_show = false;

                            _this.promotionQRLists();
                        } else {
                            _this.card_code = [];
                            this.$message.error('当前列表无数据，不能下载');
                        }
                    }
                })
                .catch((err) => {});
        },
        // 选择创建时间
        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.created_at = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.created_at = '';
            }
        },
        // 列表初始化
        offlineDiscountCardLists() {
            console.log(333);
            _this
                .$post('/offlinediscountcard/offlineDiscountCardLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].loading = false;
                        res.data[i].index = i;
                    }
                    _this.tableData = res.data;

                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].qrcode.hash);
                        _this.srcList.push(res.data[i].qrcode.url);
                    }
                })
                .catch((err) => {});
        },

        // 列表下载
        downZipPromotionQR(code) {
            _this.card_code = [];
            _this.card_code.push(code.card_code);

            _this.tableData[code.index].loading = true;

            _this.downZipBusiness(code.index);
        },
        // 批量下载
        batchDownZipPromotionQR() {
            console.log('批量下载');
            if (_this.card_code.length == 0) {
                this.$message.error('请选择要下载的数据');
                return;
            }

            _this.downZipBusiness('piliang');
        },
        downZipBusiness(index) {
            axios({
                method: 'POST',
                url: config.axios_baseURL + '/offlinediscountcard/downZipPromotionQR',

                data: {
                    card_code: _this.card_code
                },
                responseType: 'blob'
            })
                .then((response) => {
                    if (index != 'piliang') {
                        _this.tableData[index].loading = false;
                    }

                    const fileName = '优惠卡下载';
                    /* 兼容ie内核，360浏览器的兼容模式 */
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        window.navigator.msSaveOrOpenBlob(blob, 'fileName');
                    } else {
                        /* 火狐谷歌的文件下载方式 */
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a'); // 创建a标签
                        link.href = url;
                        link.download = fileName; // 文件重命名，若无需重命名，将该行删去
                        link.click();
                        URL.revokeObjectURL(url); // 释放内存
                    }
                    _this.card_code = [];
                    _this.offlineDiscountCardLists();

                    resolve(response);
                })
                .catch((error) => {
                    // _this.$errorMsg(error)
                });
        },
        // 列表删除

        deletePromotionQR(code) {
            console.log(1111);
            _this.card_code = [];
            _this.card_code.push(code.card_code);

            this.$confirm('您确认要删除吗？删除后，优惠卡将作废！数据统计将失效，请慎重操作！ 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this
                        .$post('/offlinediscountcard/deleteofflineDiscountCardSubmit', {
                            card_code: _this.card_code
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            _this.card_code = [];
                            console.log(_this.card_code, '_this.card_code');
                            _this.offlineDiscountCardLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.card_code = [];
                    _this.offlineDiscountCardLists();
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 批量删除
        batchDelete() {
            if (_this.card_code.length == 0) {
                _this.$message.warning('请至少勾选一条数据');

                return;
            }

            _this
                .$confirm('您确认要删除吗？删除后，优惠卡将作废！数据统计将失效，请慎重操作！ 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    // _this.card_code = JSON.stringify(_this.card_code);

                    _this
                        .$post('/offlinediscountcard/deleteofflineDiscountCardSubmit', {
                            card_code: _this.card_code
                        })
                        .then((res) => {
                            console.log(res);

                            _this.$message.success('删除成功!');

                            _this.card_code = [];
                            console.log(_this.card_code, '_this.card_code');
                            _this.offlineDiscountCardLists();

                            return;
                        })
                        .catch((err) => {
                            console.log(err);
                        });

                    // _this.card_code = JSON.parse(_this.card_code);
                })
                .catch(() => {
                    _this.card_code = [];
                    _this.offlineDiscountCardLists();
                    _this.$message.info('已取消删除');
                });
        },
        // 搜索
        searchOfflineDiscountCardLists() {
            _this.search_data.page = 1;
            _this.offlineDiscountCardLists();
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.offlineDiscountCardLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
